import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Footer = styled.footer`
  align-items: center;
  background-color: #000000;
  display: flex;
  height: 100px;
  width: 100%;
  & a, p  {
  color: white;
  cursor: pointer;
  font-size: 14px;
  padding-left: 30px;
  //min-height: 30px;
  text-decoration: none;
} &  a:hover {
  text-decoration: underline;
}
@media only screen and (max-width: 600px) {
    align-items: flex-start;
    flex-direction: column;
}
`;
